<app-flight-card-mobile [content]="'flex'">
  <ng-container title>{{ title }}</ng-container>

  <ng-container subtitle>
    <div class="mt-2">
      <p-tag [styleClass]="badgeStyleClass" [value]="badgeLabel"></p-tag>
    </div>
  </ng-container>

  <ng-container content>
    <app-assigned-item-meta class="text-sm" [meta]="meta"></app-assigned-item-meta>
  </ng-container>

  <ng-container actions>
    <app-flight-card-cta
      class="w-full"
      actions
      [flight]="data"
      [type]="type"
      [isEditable]="showEdit"
      [canBeArchived]="true"
      [asListRow]="asListRow"
    ></app-flight-card-cta>
  </ng-container>
</app-flight-card-mobile>
